import { currentPageActions } from '../../services';

export const currentPageDispatcher = dispatch => ( {
  setPage: page => dispatch( { type: currentPageActions.SETPAGE, page } ),
} );